import"./../ContentBlock/ContentBlock.css.ts.vanilla.css";import"./FAQs.css.ts.vanilla.css";var r="_1av73vp0";export{r as FAQsContainer};
